import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, accent, description, image, testId }) => (
  <section className="relative pt-32 sm:pt-40 pb-16 sm:pb-20 overflow-hidden" data-testid={testId}>
    {image && (
      <>
        <div
          className="absolute inset-0 bg-cover bg-center opacity-25"
          style={{ backgroundImage: `url(${image})` }}
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1520]/70 via-[#0B1520]/85 to-[#0B1520]" aria-hidden="true" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-xs font-mono-club uppercase tracking-[0.25em] text-[#E5AC3C] mb-4"
      >
        {eyebrow}
      </motion.p>
      <h1 className="font-head text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] max-w-3xl">
        <span className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          >
            {title}
          </motion.span>
        </span>
        {accent && (
          <span className="block overflow-hidden">
            <motion.span
              className="block font-serif-accent font-medium text-[#E5AC3C]"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.8, delay: 0.22, ease: [0.22, 1, 0.36, 1] }}
            >
              {accent}
            </motion.span>
          </span>
        )}
      </h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.35 }}
          className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-[#9BB0C1]"
        >
          {description}
        </motion.p>
      )}
    </div>
  </section>
);
